<template>
    <div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :showRealCom="true" :selectRealComId="queryModel.filterItems.retailerRealComId" :showMgmt="true" :mgmtRelaySeq="true" :bizDepart="true" :tmpBizDepart="false"
                                  :selectComId="queryModel.filterItems.retailerComId" :showIncludeSubComs="true" :initIncludeSubComs="initIncludeSubComs" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row" name="btns">
            <div class="left">
                <div v-if="checkActionPerm('create')" class="swb-btn swb-btn-small" @click="toSaveSplitForm(null)">
                    <span>新增</span>
                </div>
            </div>
            <div class="right"></div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect"
                          :rowKeyPropName="rowKeyPropName"
                          :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import {Utils, $, EventBus} from '../../app.base'
    import {Vue, MsgBox, Routes, DomSizeWatcher} from '../../app.vues'
    import {checkUserActionPerm} from '../index'
    import {getDefaultPageSizes} from '../../app.conf'
    import {getIncludeSubComsByMetaQueryConf} from '../conf/ComnConfStorer'
    import {openAuditDlg} from '../bizUnion/selectDlg';
    import {showComActionPostSelectDlg} from '../merchant/showSelectDlg'
    import {openDevcSplitFormSavelDlg, openDevcSplitFormDetailDlg, openDevcSplitAuditRecListDlg} from './showDlg'

    import devcApi from '../../api/devc'
    import userApi from '../../api/user'

    export default {
        name: 'swb-devc-split-form-list',
        path: '/devc/split/form/list/get',
        desc: '资产拆分单管理',
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                confKey: 'swb-devc-split-form-list',
                theTableHeight: 300,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                //
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                // 过滤信息
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                filterItems: {},
                initIncludeSubComs: false,
                selectComId: null,
                selectComFullName: null,
                // 其他信息
                formList: [],
                auditStateMap: getEnumMap('auditState', 'value2text'),
                innerNo: null
            }
        },
        created: function () {
            let self = this;
            this.pageSize = this.pageSizes.first();
            //
            let innerNo = this.$route.query.innerNo || null;
            if(!Utils.isNoB(innerNo)) {
                this.queryModel.filterItems.innerNo = innerNo;
                this.innerNo = innerNo;
            }
            //
            this.getCurrentUserInfo();
            //
            getIncludeSubComsByMetaQueryConf("swb-devc-split-form-list", function (includeSubComs) {
                let filterItems = self.filterItems || {};
                filterItems.includeSubComs = includeSubComs;
                self.filterItems = Utils.merge({}, filterItems);
                self.initIncludeSubComs = includeSubComs;
            });
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.org-tree-layout, [name="query-sort-block"], [name="btns"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            checkActionPerm: function (action, targetPostId, dataOwnerComId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId, dataOwnerComId);
            },
            checkComCatChange: function (eventData) {
                let filterItem = this.filterItems || {};
                if (Utils.isTrue(eventData.realFlag)) {
                    filterItem.retailerRealComId = eventData.id;
                    this.selectComId = null;
                    this.selectComFullName = null;
                } else if (Utils.isTrue(eventData.centerFlag)) {
                    filterItem.retailerRealComId = eventData.realComId;
                    filterItem.selectPrftCenterCode = eventData.code;
                    this.selectComId = null;
                    this.selectComFullName = null;
                } else {
                    filterItem.retailerComId = eventData.id;
                    filterItem.includeSubComs = eventData.includeSubComs;
                    this.selectComId = eventData.id;
                    this.selectComFullName = eventData.fullName;
                }
                this.filterItems = Utils.merge({}, filterItem);
                //
                this.getDevcSplitFormList();
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        let scopeEntity = data.scopeEntity;
                        self.scopeEntity = scopeEntity;
                        //
                        let filterItem = self.filterItems || {};
                        filterItem.retailerComId = scopeEntity.bizUnitId;
                        self.filterItems = Utils.merge({}, filterItem);
                        self.selectComId = scopeEntity.bizUnitId;
                        self.selectComFullName = scopeEntity.bizUnitName;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            onQueryConfigReady: function () {
                // 状态
                let dataList = [{"value": null, "label": "- 全部 -"}];
                dataList.push({"value": "applyInitial", "label": "待申请"});
                dataList.push({"value": "auditInitial", "label": "待审核"});
                dataList.push({"value": "auditPass", "label": "审核通过"});
                dataList.push({"value": "auditFail", "label": "审核未通过"});
                this.updateQueryModelField("state", dataList);
                //
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let innerNo = this.innerNo;
                if(!Utils.isNoB(innerNo)) {
                    let data = {value: innerNo};
                    let fieldInfo = {};
                    fieldInfo["innerNo"] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'state': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.applyState == 0) {
                            return "<span>待申请</span>";
                        } else if (row.applyState == 1 && row.auditState == 0) {
                            return "<span>待审核</span>";
                        } else {
                            return "<span>" + self.auditStateMap[row.auditState] + "</span>";
                        }
                    },
                    'auditorDepartFullName': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.auditorDepartFullName == null) {
                            return "<span>" + (Utils.isNoB(row.auditBizUnitName) ? '' : row.auditBizUnitName) + "</span>";
                        } else {
                            return "<span>" + row.auditorDepartFullName + "</span>";
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        if (self.checkActionPerm('view_detail', null, row.retailerComId)) {
                            btnList.push({
                                name: 'view_detail',
                                text: '查看'
                            });
                        }
                        if (self.checkActionPerm('modify', null, row.retailerComId) && !row.invalid && (row.applyState == 0 || (row.applyState == 2 && row.auditState == -1))) {
                            btnList.push({
                                name: 'modify',
                                text: '编辑'
                            });
                        }
                        if (self.checkActionPerm('do_apply', null, row.retailerComId) && !row.invalid && row.applyState == 0) {
                            btnList.push({
                                name: 'do_apply',
                                text: '申请'
                            });
                        }
                        if (self.checkActionPerm('do_audit', row.auditorPostId, row.retailerComId) && !row.invalid && row.applyState == 1 && row.auditState == 0) {
                            btnList.push({
                                name: 'do_audit',
                                text: '审核'
                            });
                        }
                        if (self.checkActionPerm('audit_rec', null, row.retailerComId)) {
                            btnList.push({
                                name: 'audit_rec',
                                text: '审核记录'
                            });
                        }
                        if (self.checkActionPerm('do_delete', null, row.retailerComId) && (row.applyState == 0 || (row.applyState == 2 && row.auditState == -1))) {
                            btnList.push({
                                name: 'do_delete',
                                text: '删除'
                            });
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if (!Utils.repeatChecker.isValidFor(btnName, 1000)) {
                            return;
                        }
                        if (btnName == 'view_detail') {
                            self.viewSplitForm(row.id);
                        } else if (btnName == 'modify') {
                            self.toSaveSplitForm(row);
                        } else if (btnName == 'do_apply') {
                            // 申请
                            self.toApply(row);
                        } else if (btnName == 'do_audit') {
                            // 审核
                            self.toAudit(row);
                        } else if (btnName == 'audit_rec') {
                            // 查看审核操作记录
                            self.viewAuditRec(row.id);
                        } else if (btnName == 'do_delete') {
                            // 删除
                            self.doDelete(row.id);
                        }
                    }
                });
            },
            //
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDevcSplitFormList();
            },
            //
            pageNoChangeHandler: function (pageNumber, pageSize) {
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDevcSplitFormList();
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 查询拆分单列表
            getDevcSplitFormList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                let filter = self.filterItems || {};
                filterItems = Object.assign(filterItems, filter);
                //
                if (!Utils.isNoB(filterItems.state)) {
                    if (filterItems.state == 'applyInitial') {
                        filterItems.applyState = 0;
                        filterItems.auditState = null;
                    } else if (filterItems.state == 'auditInitial') {
                        filterItems.applyState = 1;
                        filterItems.auditState = 0;
                    } else if (filterItems.state == 'auditPass') {
                        filterItems.applyState = 2;
                        filterItems.auditState = 1;
                    } else if (filterItems.state == 'auditFail') {
                        filterItems.applyState = 2;
                        filterItems.auditState = -1;
                    }
                } else {
                    filterItems.applyState = null;
                    filterItems.auditState = null;
                }
                //
                if (!Utils.isNoB(filterItems.retailerRealComId)) {
                    filterItems.useRealQuery = true;
                }
                if (Utils.isTrue(filterItems.useRealQuery)) {
                    filterItems.retailerComId = null;
                    filterItems.retailerComId = null;
                }
                if (!Utils.isNoB(filterItems.selectPrftCenterCode)) {
                    filterItems.prftCenterCode = filterItems.selectPrftCenterCode;
                    filterItems.usePrftCenterQuery = true;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                devcApi.getDevcSplitFormPageList(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        self.formList = result.data.rows || [];
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(self.formList, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 保存拆分单
            toSaveSplitForm: function (row) {
                let self = this;
                let title = '拆分单 - 新增';
                let id = null;
                let showApplyBtn = self.checkActionPerm('do_apply');
                if (!Utils.isNoB(row)) {
                    title = '拆分单 - 编辑';
                    id = row.id;
                    showApplyBtn = self.checkActionPerm('do_apply', null, row.retailerComId) && !row.invalid && row.applyState == 0;
                }
                let params = {
                    id: id,
                    comId: self.selectComId,
                    comFullName: self.selectComFullName,
                    title: title,
                    showApplyBtn: showApplyBtn
                };
                openDevcSplitFormSavelDlg(params, function (splitForm, theDlg, applyFlag) {
                    if (Utils.isTrue(applyFlag)) {
                        self.toApply(splitForm, theDlg);
                    } else {
                        //
                        let theLoading = MsgBox.loading();
                        devcApi.saveDevcSplitForm(splitForm, function (result) {
                            theLoading.close();
                            if (result.type == 'info') {
                                theDlg.close();
                                MsgBox.success("保存成功！");
                                self.getDevcSplitFormList();
                            } else {
                                let msgs = result.message.split('\n');
                                MsgBox.warning(msgs.join('<br/>'));
                            }
                        });
                    }
                });
            },
            // 查看详情
            viewSplitForm: function (id) {
                let params = {
                    id: id
                };
                openDevcSplitFormDetailDlg(null, params);
            },
            // 申请
            toApply: function (row, theDlg) {
                let self = this;
                //
                showComActionPostSelectDlg({
                    title: '拆分单申请 - 指定审核岗',
                    rescUrl: Vue.$getClassInfo(this).path,
                    action: 'do_audit',
                    initPostId: row.auditorPostId,
                    useParents: true,
                    descLabel: '申请描述',
                    applyDesc: row.applyDesc
                }, function (resultData) {
                    resultData = resultData || {};
                    if (resultData.postId == null) {
                        Toast.show('请选择审核岗位', 3000, 'warning');
                        return false;
                    }
                    //
                    let postData = {};
                    if (!Utils.isNoB(theDlg)) {
                        postData = Utils.merge({}, row);
                        postData.autoApply = true;
                    } else {
                        postData.id = row.id;
                    }
                    postData.applyDesc = resultData.applyDesc;
                    postData.auditorPostId = resultData.postId;
                    postData.auditorPostName = resultData.postName;
                    if (!Utils.isNoB(theDlg)) {
                        //
                        let theLoading = MsgBox.loading();
                        devcApi.saveDevcSplitForm(postData, function (result) {
                            theLoading.close();
                            if (result.type == 'info') {
                                theDlg.close();
                                MsgBox.success("申请成功！");
                                self.getDevcSplitFormList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    } else {
                        devcApi.doApplyDevcSplitForm(postData, function (result) {
                            if (result.type == 'info') {
                                MsgBox.success("申请成功");
                                self.getDevcSplitFormList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }
                }, this);
            },
            // 审核
            toAudit: function (row) {
                let self = this;
                //
                openAuditDlg(row, function (result) {
                    if (!Utils.isNoB(result)) {
                        let postData = {
                            id: row.id,
                            auditState: result.resource,
                            auditDesc: result.desc
                        };
                        let theLoading = MsgBox.loading();
                        devcApi.doAuditDevcSplitForm(postData, function (result) {
                            theLoading.close();
                            if (result.type == 'info') {
                                if (Utils.isNoB(result.message)) {
                                    MsgBox.success("操作成功");
                                } else {
                                    // 为能提供报修服务，请绑定商品标识码
                                    let msgList = [];
                                    msgList.add('操作成功');
                                    msgList.add(result.message);
                                    MsgBox.success(msgList.join("<br/>"));
                                }
                                self.getDevcSplitFormList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }
                });
            },
            // 查看审核操作记录
            viewAuditRec: function (id) {
                openDevcSplitAuditRecListDlg(id);
            },
            // 删除
            doDelete: function (id) {
                let self = this;
                this.$confirm('确定要删除吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    //
                    let theLoading = MsgBox.loading();
                    devcApi.doDeleteDevcSplitForm(postData, function (result) {
                        theLoading.close();
                        if (result.type == 'info') {
                            MsgBox.success("操作成功");
                            self.getDevcSplitFormList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcSplit/DevcSplitFormList.vue